<tabs-pds3 htmlId="Tabs-Note" srLabel="notes-tabs" selectedTabId="TemporaryNote">
    <tablist-pds3>
        <tab-pds3 tabId="TemporaryNote">{{ "CardModal.TemporaryNote" | translate }}</tab-pds3>
        <tab-pds3 tabId="PermanentNote">{{ "CardModal.PermanentNote" | translate }}</tab-pds3>
    </tablist-pds3>
    <tab-line-pds3></tab-line-pds3>
    <tab-panels-pds3>
        <tab-panel-pds3 panelId="TemporaryNote">
            <textarea-field-pds3 label="">
                <textarea
                    name="textarea-name-textarea-story1"
                    id="textarea-id-textarea-story1"
                    class="fancy-scrollbar-newUI"
                    formControlName="temporaryNote"
                ></textarea>
            </textarea-field-pds3>
        </tab-panel-pds3>
        <tab-panel-pds3 panelId="PermanentNote">
            <textarea-field-pds3 label="">
                <textarea
                    name="textarea-name-textarea-story2"
                    id="textarea-id-textarea-story2"
                    class="fancy-scrollbar-newUI"
                    formControlName="note"
                ></textarea>
            </textarea-field-pds3>
        </tab-panel-pds3>
    </tab-panels-pds3>
</tabs-pds3>
